import { eKeHoachTuanActionsObj } from "../../action-types/ke-hoach/IKeHoachTuanActions";
import { generateActions } from "../generateActions";

export const keHoachTuanActions = {
  ...generateActions(eKeHoachTuanActionsObj, "KE_HOACH_TUAN"),
};
